(function () {
  if (window.__landingOfferButtonScrollInitialized) return;
  window.__landingOfferButtonScrollInitialized = true;

  var SELECTOR = '.offer-button-wrapper';

  function getScrollTarget() {
    if (document.body.hasAttribute('hl8-landing-page-ABtest-v1')) {
      return document.querySelector('.landing-product-variant-picker.ABtest');
    }
    if (document.body.hasAttribute('hl8-landing-page-ABtest-v2')) {
      return document.querySelector('.landing-product-variant-picker-v2.ABtest');
    }
    return document.getElementById('featured-product-section');
  }

  function scrollToTarget(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest(SELECTOR);
      if (!button) return;

      event.preventDefault();
      scrollToTarget(getScrollTarget());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
